module.exports = __webpack_public_path__ + "media/images/emblems/Hergiswil_LU-b42006463721db78e54b9a3f904bf4f5.png";